import { OpenSeaPort } from 'opensea-js'
import { OpenSeaAssetQuery, WyvernSchemaName } from 'opensea-js/lib/types'

import { OPENSEA_ASSET_CONTRACT_ADDRESS, OPENSEA_COLLECTION_SLUG } from '@/lib/constants'

export const getMyAssets = async ({
  seaport,
  account,
  query,
  page = 1,
}: {
  seaport: OpenSeaPort
  account: string
  query?: OpenSeaAssetQuery
  page?: number
}) => {
  const optionalQuery = query ? query : {}
  const assets = await seaport.api.getAssets(
    {
      ...optionalQuery,
      asset_contract_address: OPENSEA_ASSET_CONTRACT_ADDRESS,
      owner: account,
      collection: OPENSEA_COLLECTION_SLUG,
    } as OpenSeaAssetQuery,
    page
  )

  return assets
}

export const isMyAsset = async ({
  seaport,
  account,
  tokenId,
}: {
  seaport: OpenSeaPort
  account: string
  tokenId: string
}) => {
  const asset = {
    tokenAddress: OPENSEA_ASSET_CONTRACT_ADDRESS,
    tokenId,
    schemaName: WyvernSchemaName.ERC1155,
  }
  const balance = await seaport.getAssetBalance({
    accountAddress: account,
    asset,
  })

  return balance.greaterThan(0)
}
